import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractRestService } from '../../../../core/services/AbstractRestService';
import { IAuditorium, ISeatsConnection } from '../../interfaces';

@Injectable({
  providedIn: 'root'
})
export class ConnectionApiService extends AbstractRestService<IAuditorium> {

  protected readonly basePath = '/auditoriums/seat-definitions/connection';

  public setSeatsConnections(seatsConnections: ISeatsConnection[]): Observable<void> {
    return this.apiService.put(this.basePath, {seatsConnections});
  }
}
